import styled from 'styled-components';

import colors from '@/design/colors';
import { HeadingLarge, HeadingSmall } from '@/design/typography';
import CheckboxLabel from '@/components/CheckboxLabel';

export const Panel = styled.div`
  /* Layout */
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  gap: 8px;

  /* Colors */
  background-color: ${colors.gray100};
`;

export const PanelHeading = styled.div`
  /* Layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const PanelTitle = styled(CheckboxLabel).attrs({ size: 'small' })`
  ${HeadingLarge(14)};
  color: ${colors.blackAlpha200};
`;

export const PanelFeedback = styled(CheckboxLabel).attrs({ size: 'small' })`
  ${HeadingSmall(14)};
  color: ${colors.blackAlpha100};
`;

export const PanelActions = styled.div`
  /* Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
